import type { TransactionPredicate } from './types';

export const isHighlighted: TransactionPredicate = ({ additionalData }) =>
    Boolean(additionalData?.marked);
